import script from "./CartBcIntro.vue?vue&type=script&lang=ts&setup=true"
export * from "./CartBcIntro.vue?vue&type=script&lang=ts&setup=true"

import "./CartBcIntro.vue?vue&type=style&index=0&id=ef26409e&lang=scss&scoped=true"
import "./CartBcIntro.vue?vue&type=style&index=1&id=ef26409e&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef26409e"]])

export default __exports__